import colors from "tailwindcss/colors";

interface IProps {
  title: string;
  description: string;
  Icon: React.ElementType;
}

export const EmptyState: React.FC<IProps> = ({ title, description, Icon }) => {
  return (
    <section className="flex flex-col items-center">
      <div className="mb-2 flex h-[80px] w-[80px] items-center justify-center rounded-full bg-slate-200">
        <Icon color={colors.gray[600]} size={42} />
      </div>
      <h2 className="mb-2 text-2xl font-bold">{title}</h2>
      <span className="max-w-[640px] text-center text-base font-normal text-slate-600">{description}</span>
    </section>
  );
};
